import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { ClientBO } from '../pages/client-parent/client-parent.model';
import { CommonHttpService } from '../common.service';
import { takeUntil } from 'rxjs/operators';
import { interval, Subject, Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from '../service/general.service';
import { EmployeeBO } from '../pages/employee/employee.model';
import { SwUpdate } from '@angular/service-worker';
import { DatePipe } from '@angular/common';

@Component({
  template: '',
})

export class GlobalComponent implements OnInit {
  public globalColumn: any = [];
  globalLocationList: any = [];
  selectedAgencyDropdown: any = [];
  selectedLocationDropdown: any = [];
  public LegStatusFilter: any = [];
  public DriverList: any = [];
  public globalAgencyDropDown: any = [];
  public globalICD10List: any = [];
  public userRoleDropDown: any = [];
  public sideMenuItems: any = [];
  public ngAgencyDropDown: any = [];
  public ngLocationDropDown: any = [];
  public globalLocationDropDown: any = [];
  public globalFeatures: any = [];
  public LoginEntityId:any;
  agencyData: any = {};
  LovValues: any = [];


  globalclientdata: ClientBO = new ClientBO();
  globalemployeedata: EmployeeBO = new EmployeeBO();
  public userDetail: any = {};
  private onDestroy$: Subject<void> = new Subject<void>();

  refreshSubscription: Subscription;

  public agencyCode: string = "";
  public username: string = "";
  public roles: string = "";

  public isClient: string;
  public OnboardType: string
  public portalAgencyCode: string
  public clientDocId: any;
  public clientagreementid: any;
  public employeeTemplateId: string | null;
  agencysName: string;
  public LoginEntityType: string;
  public onboardingId: string = "";
  public LoginTypeFields: string = "";
  public fms_onboardagencycode: string = "";
  public globalroleName: string;
  reporttype: string = "";
  reportday: number = 0;
  OnboardingLoginType: string = "";

  public isEditCustomer: boolean;
  public isEditAgent: boolean;
  public isEditCsp: boolean;
  public isEditAsset: boolean;
  public authtoken: string;
  public isEditUser: boolean;
  public globalHeadAgencyId: string;
  public loginType: string;
  viewTabs: boolean = false;
  globalemployee: string = "00000000-0000-0000-0000-000000000000";
  interval: any
  isDashBoard: boolean
  isAgentOn: boolean;
  isAgentAdd: boolean;
  isAgentDel: boolean;
  isAgentEdit: boolean;
  isAgentUpdate: boolean;
  isAssetOn: boolean;
  isAssetAdd: boolean;
  isAssetDel: boolean;
  isAssetEdit: boolean;
  isAssetUpdate: boolean;
  isCustomerOn: boolean;
  isCustomerAdd: boolean;
  isCustomerDel: boolean;
  isCustomerEdit: boolean;
  isCustomerUpdate: boolean;
  isCspOn: boolean;
  isCspAdd: boolean;
  isCspDel: boolean;
  isCspEdit: boolean;
  isCspUpdate: boolean;
  isMapCsp: boolean;
  isBankService: boolean;
  isAccount: boolean;
  isCashIn: boolean;
  isCashOut: boolean;
  isFund: boolean;
  menu: boolean;
  cashin: boolean;
  cashout: boolean;
  fund: boolean;
  view: Boolean;
  calendarHeightdefault: string;
  calendarHeight: string;
  calendarHeight1: string;
  globalclaimfilter: any = null;
  editAgentId: string = "00000000-0000-0000-0000-000000000000";
  isViewEmployeefields: boolean = true;
  isclientportal: boolean
  isClientOnboard = false
  globalAgencyName: string
  onboardRoles: string;
  public apiKey: any;
  public otpuserId: any;
  public otp: any;
  public ResendEmail: any;
  public ResendAgencycode: any;
  public driverAdmin: any;
  public employee_ID: string;
  public group_Payor_ID: any;
  public security_Level: any;
  public docbool: boolean = false;
  public clientId: string;
  public userID: string;
  public globalClientmedicationId: string;

  public startTime: any;
  public timefrom: any;
  public driverName: any;
  public Van_ID: string;
  public getdate: any;
  public date: any = new Date();
  public ViewAll: boolean;
  public ShowOnly: boolean;
  public isAllData: boolean;
  public Accessright: boolean;
  public requestId: string;
  public tblID: any;
  public emp_ID: string;
  public leg: any;
  public etblID: any;
  public deviceWidth: number;
  public van_ID: any;
  public etransID: any;
  public editinsnum: any;
  public FlatRatetblID: any;
  public transid: any;
  public tripDate: any;
  public locname: any;
  public tophy: any;
  public city: any;
  public state: any;
  public zip: any;
  public cllocname: any;
  public fromaddress: any;
  public fromaddress2: any;
  public city1: any;
  public zip1: any;
  public state1: any;
  onboardUserName: string;
  public altAddress1: any;
  public altAddress2: any;
  public altCity: any;
  public altHomeType: any;
  public altState: any;
  public altZip: any;
  public multipleriders: any;
  public loginUser: any;
  public globalAgencyId: any = "00000000-0000-0000-0000-000000000000";
  public logginedUserName: any;
  public clientonboard: any;
  public agencyName: any = null;

  public LocationName: any = null;
  public agencyPhone: any = null;
  public agencyLogo: any = null;
  public loading: boolean = false;
  public roleId: string = "ADMIN";
  public listId: any = 3;
  public email: string;
  public deleteErr: string;
  public ErrorBool: boolean = false;
  public userSelectedRole: string = "";
  public globalAgencyDropdown: any = "";
  public employeeSubmitSave: any
  public employeeOnboardDocumentId: string;
  public submitLovCode = ''
  public globalLocationId: any = null;
  locationData: any = 0;
  public isViewClientPageDis: boolean = false;
  public isViewClientBudget: boolean = false;
  LoginUserType: any;
  isCheckOperationDashboardRecord: boolean = false;
  globalCLaimStatus: any = null;
  globalClaimType: boolean = null;
  public isViewClientPageEna: boolean = false;
  employeetoAgreementEmit: boolean = false
  public loginusername: any;
  checkProgressTimesheet: boolean = null;
  checkProgressPurchase: boolean = null;
  checkProgressTransaction: boolean = null;
  checkProgressCSG: boolean = null;
  checkidleTime: boolean = true;
  checkidlePurchase: boolean = true;
  checkidleTransaction: boolean = true;
  checkidleCSG: boolean = true;
  isUMPI: boolean = null
  refreshTokenString:any;
  selectAgencyCode:any;
  isServiceWorkersEnabled:boolean=false;
  constructor(public update: SwUpdate,public http: HttpClient, public route: Router, public general: GeneralService, private router: Router,
    public commonservice: CommonHttpService, public toasterService: ToastrService,public datepipe:DatePipe) {
    this.getFeaturesJson();
  }

  ngOnInit() {
  }

  Adddata(data) {
    if (data.onboardingId == null || data.onboardingId == undefined) {
      this.authtoken = data.tokenString;
      this.onboardingId = null;
    }
    else {
      this.authtoken = data.accessToken;
      this.onboardingId = data.onboardingId
    }

    this.LoginUserType = data.LoginUserType;
    this.logginedUserName = data.userName;
    this.agencyLogo = data.agencyLogo;
    this.agencyName = data.agencyName;
    this.agencyPhone = data.phone;
    this.userID = data.userId;
    this.globalAgencyId = data.agencyId == "00000000-0000-0000-0000-000000000000" ? null : data.agencyId;
    if (data.userId != "00000000-0000-0000-0000-000000000000" && data.userId != null && data.userId != undefined) {
    }
    if (this.agencyPhone != null) {
      this.agencyPhone = this.general.converPhoneGoogleLib(this.agencyPhone);
    }

    if (data.menuList != undefined && data.menuList != null) {
      this.AddMenuItems(data.menuList);
    }
  }

  AddMenuItems(data) {
    let menu: any = []
    let i: number = 1;
    data.forEach(element => {
      let temp: any = {}
      temp.id = i;
      temp.title = element.title;
      temp.routerLink = element.link;
      temp.href = null;
      temp.icon = element.icon;
      temp.target = null;

      temp.parentId = 0;

      if (element.children != null && element.children.length > 0) {
        let j: number = i + 1;
        element.children.forEach(element => {
          let submenu: any = {}
          submenu.id = j;
          submenu.title = element.title;
          submenu.routerLink = element.link;
          submenu.href = null;
          submenu.icon = element.icon;
          submenu.target = null;
          submenu.hasSubMenu = false;
          submenu.parentId = i;

          menu.push(submenu);
          j++;
        });
        i = j - 1;
        temp.hasSubMenu = true;
      }
      else {
        temp.hasSubMenu = false;
      }
      menu.push(temp);
      i++;
    });
    this.sideMenuItems = menu;
    localStorage.setItem("fms_menulist", JSON.stringify(this.sideMenuItems));
  }
  Addagencydata(data) {
    this.globalHeadAgencyId = data.agencyId;
    this.selectedAgencyDropdown = (this.globalHeadAgencyId == '00000000-0000-0000-0000-000000000000') ? '' : this.globalHeadAgencyId;
    this.agencyLogo = data.agencyLogo;
    this.agencyName = data.agencyName;
    this.selectedAgencyDropdown = data.agencyName;
    this.agencyPhone = data.phone;
    if (this.agencyPhone != null) {
      this.agencyPhone = this.general.converPhoneGoogleLib(this.agencyPhone);
    }
    this.globalAgencyId = data.agencyId;
  }

  refreshAgencyDetails(selectedAgencyId) {
    this.globalAgencyId = selectedAgencyId;
    this.globalHeadAgencyId = selectedAgencyId;
    var agency_Id: string = "00000000-0000-0000-0000-000000000000";
    let url = "api/Agency/OverallAgencyInfo?";
    let myparams = new URLSearchParams();
    if (selectedAgencyId == '' || selectedAgencyId == null || selectedAgencyId == "00000000-0000-0000-0000-000000000000") {
      myparams.append("agencyId", agency_Id);
    }
    else {
      myparams.append("agencyId", selectedAgencyId);
    }
    this.http.get(url + myparams).subscribe((data: any) => {
      if (data != null) {
        localStorage.setItem("fms_agencyNames ", JSON.stringify(data));
        this.agencyLogo = data.agencyLogo;
        this.agencyName = data.agencyName;
        this.selectAgencyCode =data.agencyCode;
        if (data.phone != null) {
          data.phone = this.general.converPhoneGoogleLib(data.phone);
          this.agencyPhone = this.general.converPhoneGoogleLib(data.phone);
        }
        else {
          this.agencyPhone = null;
        }
        data.agencyId = selectedAgencyId;
        this.globalAgencyId = selectedAgencyId;
        localStorage.setItem("fms_globalagencydetails", JSON.stringify(data));
        this.route.routeReuseStrategy.shouldReuseRoute = () => false;
        this.route.onSameUrlNavigation = 'reload';
        this.route.navigate(['/operational-dashboard']);
      }
      else {
        this.agencyLogo = null;
        this.agencyName = null;
        this.agencyPhone = null;
        this.globalAgencyId = '';
        let data: any = "";
        localStorage.setItem("fms_globalagencydetails", JSON.stringify(data));
        this.route.navigateByUrl('/agency');
        this.route.routeReuseStrategy.shouldReuseRoute = () => false;
        this.route.onSameUrlNavigation = 'reload';
        this.route.navigate(['/agency']);
      }
    }
    )
  }

  checkforlogout() {
    let val = this.router.url;

    if (!(val == "/employee" || val == "/operational-dashboard ")) {
      this.globalemployee = '00000000-0000-0000-0000-000000000000';
    }
    if (!(val == "/client-batch" || val == "/client-report")) {

    }
    if (val != "/batch") {
      this.globalclaimfilter = null;
    }
    let checkforlogindetails = localStorage.getItem("fms_login");

    if (checkforlogindetails == null) {
      this.router.navigateByUrl("/login");

    }
     const maintenanceStartUtc = new Date('2026-03-12T08:00:00Z');
      const maintenanceEndUtc = new Date('2026-03-12T09:30:00Z');
      const nowUtc = new Date();
      if (nowUtc >= maintenanceStartUtc && nowUtc <= maintenanceEndUtc) {
         this.router.navigate(['/app-maintenance'], {
        state: {maintenanceEnd: maintenanceEndUtc }
      });
      }
  }

  checkforonBoardLogout() {
    let onboardCredentials = localStorage.getItem("fms_login");
    if (onboardCredentials == null) {
      let onboardagencycode = localStorage.getItem("fms_onboardagencycode");
      let logintype = localStorage.getItem("fms_onboardtype");
      this.fms_onboardagencycode = onboardagencycode;
      this.LoginTypeFields = logintype;
      if (this.LoginTypeFields == 'employee') {
        this.router.navigateByUrl("/onboarding/employee/" + this.fms_onboardagencycode);
        this.LoginTypeFields = ""
      }
      else {
        this.LoginTypeFields = ""
        this.router.navigateByUrl("/onboarding/client/" + this.fms_onboardagencycode);
      }
      this.fms_onboardagencycode = ""

    }
  }

  isalpha(c) {
    return (((c >= 'a') && (c <= 'z')) || ((c >= 'A') && (c <= 'Z')));
  }

  isdigit(c) {
    return ((c >= '0') && (c <= '9'));
  }

  isalnum(c) {
    return (this.isalpha(c) || this.isdigit(c));
  }

  refreshLocationDetails(selectedLocationId) {
    this.globalLocationId = selectedLocationId;
    if (this.globalLocationList.length > 0) {
      if (selectedLocationId != null && selectedLocationId != undefined && selectedLocationId != '') {
        let location = this.globalLocationList?.filter(a => a.Key == selectedLocationId)[0].Value;
        this.LocationName = location;
      }
    }

    localStorage.setItem("fms_location", JSON.stringify(selectedLocationId));
    this.reloadComponent();
  }
  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }
  getFeaturesJson() {
    this.globalFeatures = [];
    this.commonservice.getFeaturesJSON().subscribe((data: any) => {
      this.globalFeatures = data;
    })
  }
  
  getFeaturesByName(Name) {
    var enable
    this.globalFeatures.forEach(element => {
      if (element.featureName == Name) {
        enable = element.enabled;
      }
    });
    return enable;
  }
  
  getOverallAgencyDropDown() {
    let url = "api/Agency/OverallAgency";
    this.http.get(url).pipe(takeUntil(this.onDestroy$)).subscribe((data:any) => {
      localStorage.setItem("fms_agencyNames ", JSON.stringify(data));
      this.globalAgencyDropDown = data;
    },
      err => {
      })
  }

  //.........assignToken............................................................................................
  assignToken(data) {
    this.authtoken = data.accessToken;
    if (data.accessToken != null) {
      this.getOverallAgencyDropDown();
    }
  }
  // AddAgencyDropdown
  AddAgencyDropdown(data) {
    this.globalAgencyDropDown = data;
    this.ngAgencyDropDown = this.globalAgencyDropDown;
    this.ngAgencyDropDown.forEach(a => a.id = a.id.toString());
    this.globalAgencyDropdown = this.globalAgencyId == '00000000-0000-0000-0000-000000000000' ? '' : this.globalAgencyId;
  }
  //agency& user Details//////
  getAgencyDetails(agencyValues) {
    this.agencyCode = agencyValues.agencyCode;
    this.globalroleName = agencyValues.roleName;
    this.logginedUserName = agencyValues.userName;
    this.agencyLogo = agencyValues.agencyLogo;
    this.agencyName = agencyValues.agencyName;
    this.agencyPhone = agencyValues.phone;
    this.userID = agencyValues.userId;
    this.globalAgencyId = agencyValues.agencyId;
    if (agencyValues.userId != '00000000-0000-0000-0000-000000000000' && agencyValues.userId != null && agencyValues.userId != undefined) {

    }

    this.roleId = agencyValues.roleId;

    if (this.agencyPhone != null) {
      this.agencyPhone = this.general.converPhoneGoogleLib(this.agencyPhone);
    }
  }
  // ..................................RefreshT0ken.........................................................................
  refreshToken(): Promise<void> {
    return new Promise((resolve, reject) => {
      let url = "api/Auth/refreshToken";
      this.refreshTokenString = JSON.parse(localStorage.getItem("fms_refreshtoken "));
      let refreshpayload = {
        refreshToken: this.refreshTokenString,
        accessToken: this.authtoken
      }
      // refresh token and access token not set in the body ,because  it will set   in  interceptor. cookie will be automatically set in interceptor.
      this.http.post(url,refreshpayload).subscribe((response: any) => {
        this.authtoken = response.accessToken;
        this.refreshTokenString=response.refreshToken
        localStorage.setItem("fms_login", JSON.stringify(response));
        localStorage.setItem("fms_refreshtoken ", JSON.stringify(response.refreshToken));
        resolve(response)
      },
        (err: HttpErrorResponse) => {
          this.toasterService.error("Your Session Got Expired, Please Login", 'Session Expired');
          this.globalHeadAgencyId = "00000000-0000-0000-0000-000000000000";
          localStorage.clear();         
          this.agencyLogo = null;
          this.agencyName = null;
          this.agencyPhone = null;
          this.globalAgencyId = '';
          this.globalLocationId = '';
          this.selectedAgencyDropdown = "";
          this.selectedLocationDropdown = '';
          this.ngLocationDropDown = [];
          this.userRoleDropDown = []
          this.userSelectedRole = ""
          this.globalAgencyDropdown = "";
          this.router.navigateByUrl("/login");

          reject(err);
        });
    });
  }
  scheduleRefresh() {
    this.refreshSubscription = interval(1000 * 60 * 25).subscribe(() => {
      this.refreshToken().catch(() => {
        this.refreshSubscription?.unsubscribe();
      });
    });
  }
  // for Onboarding Refresh token
  OnboardingrefreshToken(): Promise<void> {
    return new Promise((resolve, reject) => {
      let url = "api/Auth/refreshToken";
      let refreshpayload = {
        refreshToken: this.refreshTokenString,
        accessToken: this.authtoken
      }
      // refresh token and access token not set in the body ,because  it will set   in  interceptor. cookie will be automatically set in interceptor.
      this.http.post(url,refreshpayload).subscribe((response: any) => {
        this.authtoken = response.accessToken;
        this.refreshTokenString=response.refreshToken;
        this.LoginUserType = 'Onboard';
        response.LoginUserType = 'Onboard';
        localStorage.setItem("fms_login", JSON.stringify(response));
        resolve(response)
      },
        (err: HttpErrorResponse) => {
          this.toasterService.error("Your Session Got Expired, Please Login", 'Session Expired');
          this.globalHeadAgencyId = "00000000-0000-0000-0000-000000000000";
          this.agencyLogo = null;
          this.agencyName = null;
          this.agencyPhone = null;
          this.globalAgencyId = '';
          this.globalLocationId = '';
          this.selectedAgencyDropdown = "";
          this.selectedLocationDropdown = '';
          this.ngLocationDropDown = [];
          this.userRoleDropDown = []
          this.refreshTokenString = null;
          this.userSelectedRole = ""
          this.globalAgencyDropdown = "";
          this.LogoutFunction();
          localStorage.clear();
          reject(err);
        });
    });
  }
  OnboardingscheduleRefresh() {
    this.refreshSubscription = interval(1000 * 60 * 25).subscribe(() => {
      this.OnboardingrefreshToken().catch(() => {
        this.refreshSubscription?.unsubscribe();
      });
    });
  }
  assignOnboardingToken(data) {
    this.authtoken = data.accessToken;
  }

  onboardingdetails(list) {
    this.onboardingId = list.onboardingId;
    this.LoginUserType = list.LoginUserType;
  }

  onboardsideMenus(data) {
    let menu: any = []
    let i: number = 1;
    data.forEach(element => {
      let temp: any = {}
      temp.id = i;
      temp.title = element.title;
      temp.routerLink = element.routerLink;
      temp.href = null;
      temp.icon = element.icon;
      temp.target = null;
      temp.parentId = '00000000-0000-0000-0000-000000000000';
      if (element.children != null && element.children.length > 0) {

        let j: number = i + 1;
        element.children.forEach(element => {
          let submenu: any = {}
          submenu.id = j;
          submenu.title = element.title;
          submenu.routerLink = element.routerLink;
          submenu.href = null;
          submenu.icon = element.icon;
          submenu.target = null;
          submenu.hasSubMenu = false;
          submenu.parentId = i;

          menu.push(submenu);
          j++;
        });
        i = j - 1;
        temp.hasSubMenu = true;
      }
      else {
        temp.hasSubMenu = false;
      }
      menu.push(temp);
      i++;
    });
    this.sideMenuItems = menu;
    localStorage.setItem("fms_menulist", JSON.stringify(this.sideMenuItems));
  }

  LogoutFunction() {
    this.agencyLogo = null;
    this.agencyName = null;
    this.agencyPhone = null;
    this.globalAgencyId = null;
    this.globalLocationId = null;
    this.globalAgencyDropdown = null;
    this.selectedLocationDropdown = '';
    this.selectedAgencyDropdown = '';
    this.ngLocationDropDown = [];
    this.userRoleDropDown = []
    let onboardagencycode = localStorage.getItem("fms_onboardagencycode");
    let logintype = localStorage.getItem("fms_onboardtype");
    this.fms_onboardagencycode = onboardagencycode;
    this.LoginTypeFields = logintype;
    if (this.fms_onboardagencycode != "" && this.fms_onboardagencycode != null && this.fms_onboardagencycode != undefined) {
      if (this.LoginTypeFields == 'employee') {
        this.router.navigateByUrl("/onboarding/employee/" + this.fms_onboardagencycode);
        this.LoginTypeFields = ""
      }
      else {
        this.LoginTypeFields = ""
        this.router.navigateByUrl("/onboarding/client/" + this.fms_onboardagencycode);
      }
      this.fms_onboardagencycode = ""
    } else {
      this.router.navigateByUrl("/login");
    }
    localStorage.clear();
    this.userSelectedRole = ""
    this.globalHeadAgencyId = "00000000-0000-0000-0000-000000000000";
    this.refreshSubscription?.unsubscribe();
  }

  //..............................................getDateTimeString...................................................
  getDateTimeString(date: any): string {
    var tzoffset = (new Date(date)).getTimezoneOffset() * 60000; //offset in milliseconds
    return (new Date(new Date(date).getTime() - tzoffset)).toISOString().slice(0, -1);
  }

  //........................................................GetLocationDropDown...............................................
  GetLocationDropDown() {
    let url = "api/Location/GetLocationDropDown";
    this.http.get(url).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this.globalLocationList = data;
      let Loc = JSON.parse(localStorage.getItem("fms_location"));
      if (this.globalLocationList.length > 0) {
        if (Loc != null && Loc != undefined && Loc != '') {
          let location = this.globalLocationList?.filter(a => a.Key == Loc)[0].Value;
          this.LocationName = location;
        }
      }
    },
      err => {
      })
  }
  // ...................................................getLocation for userdropdown............................................

  userlocation: any;
  getLocationforagencyuser() {
    let UserType = localStorage.getItem("agencyLogin");
    if (UserType != "SUPERADMIN" && this.LoginTypeFields != 'employee' && !this.isClientOnboard) {
      let url = "api/User/GetLocationDropDownForUSER?";
      return this.http.get(url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.userlocation = data;
        this.globalLocationList = this.userlocation;
      })
    }
  }
  //........................................checkClaimCreationProgressForTimesheet............................................
  checkClaimCreationProgressForTimesheet(id) {
    if (id != null && id != undefined && id != '') {
      let url = "api/Claims/checkClaimCreationProgress?";
      let myParams = new URLSearchParams();
      myParams.append("progressId", id)
      this.http.get(url + myParams).pipe().subscribe((data: any) => {
        this.checkProgressTimesheet = data;
        this.checkidleTime = false;
        if (data == true) {
          setTimeout(() => {
            this.checkClaimCreationProgressForTimesheet(id);
          }, 5000);
        }
        else {
          clearInterval(this.interval);
          id = null
        }
      },
      )
    }
  }
  //..........................scheduleClaimProgressForTimesheet........................................................
  scheduleClaimProgressForTimesheet(id) {
    this.interval = setTimeout(() => {
      this.checkClaimCreationProgressForTimesheet(id);
    }, 1000);
  }

  //........................................checkClaimCreationProgressForPurchase............................................
  checkClaimCreationProgressForPurchase(id) {
    if (id != null && id != undefined && id != '') {
      let url = "api/Claims/checkClaimCreationProgressPurchase?";
      let myParams = new URLSearchParams();
      myParams.append("progressId", id)
      this.http.get(url + myParams).pipe().subscribe((data: any) => {
        this.checkProgressPurchase = data;
        this.checkidlePurchase = false;
        if (data == true) {
          setTimeout(() => {
            this.checkClaimCreationProgressForPurchase(id);
          }, 5000);
        }
        else {
          clearInterval(this.interval);
          id = null
        }
      },
      )
    }
  }
  //..........................scheduleClaimProgressForPurchase........................................................
  scheduleClaimProgressForPurchase(id) {
    this.interval = setTimeout(() => {
      this.checkClaimCreationProgressForPurchase(id);
    }, 1000);
  }
  //........................................checkClaimCreationProgressForTransaction............................................
  checkClaimCreationProgressForTransaction(id) {
    if (id != null && id != undefined && id != '') {
      let url = "api/Claims/checkClaimCreationProgressTransaction?";
      let myParams = new URLSearchParams();
      myParams.append("progressId", id)
      this.http.get(url + myParams).pipe().subscribe((data: any) => {
        this.checkProgressTransaction = data;
        this.checkidleTransaction = false;

        if (data == true) {

          setTimeout(() => {
            this.checkClaimCreationProgressForTransaction(id);
          }, 5000);

        }
        else {
          clearInterval(this.interval);
          id = null
        }
      },
      )
    }
  }
  //..........................scheduleClaimProgressForTransaction........................................................
  scheduleClaimProgressForTransaction(id) {
    this.interval = setTimeout(() => {
      this.checkClaimCreationProgressForTransaction(id);
    }, 1000);
  }

    //..........................scheduleClaimProgressForCSG........................................................
    scheduleClaimProgressForCSG(id) {
      this.interval = setTimeout(() => {
        this.checkClaimCreationProgressForCSG(id);
      }, 1000);
    }
  
    //........................................checkClaimCreationProgressForCSG............................................
    checkClaimCreationProgressForCSG(id) {
      if (id != null && id != undefined && id != '') {
        let url = "api/Claims/checkCSGClaimCreationProgress?";
        let myParams = new URLSearchParams();
        myParams.append("progressId", id)
        this.http.get(url + myParams).pipe().subscribe((data: any) => {
          this.checkProgressCSG = data;
          this.checkidleCSG = false;
          if (data == true) {
            setTimeout(() => {
              this.checkClaimCreationProgressForCSG(id);
            }, 5000);
          }
          else {
            clearInterval(this.interval);
            id = null
          }
        },
        )
      }
    }

  checkForAppUpdateAvailable() {
    console.log("checkForAppUpdateAvailable");
    this.update.versionUpdates.subscribe(event =>
      this.versionCheck(event));
  }
  //..........................versionCheck........................................................
  versionCheck(event) {
    console.log("-----event", event)
    console.log("version is available")
    if(event.type === "VERSION_READY"){
      console.log("event.type", event.type)
      this.isServiceWorkersEnabled = true;
      console.log("boolean is set as true")
    }
   
  }

checkDateValidation(sDate: any,fed: any,rangeofDate,validateDates): boolean {
  if (fed != null && fed != undefined && fed!= '') {
    if (new Date(sDate).getTime() > new Date(fed).getTime()) {
      this.toasterService.error("End Date should be greater than Start Date");
      setTimeout(() => this.toasterService.clear(), 3000);
      return false;
    }
  } }
   formatDate(dateStruct: any): string {
    const { year, month, day } = dateStruct;
    const localDate:any = new Date(year, month - 1, day);
      return localDate=="Invalid Date"?"":this.datepipe.transform(localDate, 'MM/dd/yyyy') || '';   
  }
   formatEmpWagDate(input: string): string {
    // Split the input string into year and month
    const [year, month] = input.split('-');

    // Parse year and month as numbers
    const parsedYear = parseInt(year, 10);
    const parsedMonth = parseInt(month, 10);

    // Format the month to have leading zero if necessary
    const formattedMonth = (parsedMonth < 10 ? '0' : '') + parsedMonth;

    // Construct the final date string
    const formattedDate = `${parsedYear}-${formattedMonth}-01`;

    return formattedDate;
}
 agencyList() {
    this.agencyData = JSON.parse(localStorage.getItem("ac_agencydetails"));
    if (this.agencyData?.userId == null || this.agencyData?.userId == undefined || this.agencyData?.userId == 0) {
      this.roleId = this.agencyData?.roleId;
    }
    else {
      this.roleId = localStorage.getItem("ac_role");
    }
  }

    checkSameYear(startDate,EndDate) {        
      const startYear = new Date(startDate).getFullYear();
      const endYear = new Date(EndDate).getFullYear();
      console.log(startYear,endYear);
       return startYear === endYear ? true:false;
    }
    

}

